import React from 'react'
import { Link } from 'react-router-dom'

export const MainHead = ({tittle,pera,subTitle,page,pageName,style}) => {
  return (
    <section className='main_head hero_section' style={{backgroundImage:`${style}`}}>
        <div className="container position-relative">
            <div className="text-left main_inner">
                <h1 className='heading text-white'>{tittle}</h1>
                <span>{subTitle}</span>
                <div className="line-wrape position-relative py-1"></div>
                <p className='text-white my-3'>{pera}</p>
                {/* <p className='text-white my-3'><Link to='/' className='text-white'>Home</Link><i class="fa-solid fa-forward"></i> {page} <i class="fa-solid fa-forward"></i> {pageName}</p> */}
            </div>
        </div>
    </section>
  )
}
